"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const generateItems = _ref => {
  let {
    items,
    ticked,
    inline,
    middot,
    stepped
  } = _ref;
  return items.map((item, i) => {
    let body;
    let title;
    let className;
    let content;
    let TitleComponent = "h3";
    let liProps;
    if ( /*#__PURE__*/_react.default.isValidElement(item) || typeof item === "string" || typeof item === "number") {
      content = item;
    } else if (item && typeof item === "object" && "content" in item) {
      if ("titleElement" in item) {
        ({
          title,
          className,
          content,
          titleElement: TitleComponent = "h3",
          ...liProps
        } = item);
      } else {
        ({
          title,
          className,
          content,
          ...liProps
        } = item);
      }
    }
    if (stepped) {
      body = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TitleComponent, {
        className: "p-stepped-list__title"
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: "p-stepped-list__content"
      }, content));
    } else {
      body = content;
    }
    return /*#__PURE__*/_react.default.createElement("li", _extends({
      className: (0, _classnames.default)(className, {
        "p-list__item": !inline && !stepped,
        "p-inline-list__item": inline,
        "p-stepped-list__item": stepped,
        "is-ticked": ticked
      }),
      key: i
    }, liProps), body, middot ? " " : null);
  });
};

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [List](https://docs.vanillaframework.io/patterns/lists/).
 *
 * If you want to display lists in a way that is more visually distinctive than the standard `<ol>` and `<ul>`, we have 7 list styles at your disposal.
 */
const List = _ref2 => {
  let {
    className,
    detailed,
    divided,
    inline,
    isDark,
    items,
    middot,
    stretch,
    split,
    stepped,
    ticked,
    ...props
  } = _ref2;
  const Component = stepped ? "ol" : "ul";
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: (0, _classnames.default)(className, {
      "p-list": !divided && !inline && !middot && !stretch && !stepped,
      "p-list--divided": divided,
      "p-inline-list": inline,
      "p-inline-list--middot": middot,
      "p-inline-list--stretch": stretch,
      "p-stepped-list": stepped && !detailed,
      "p-stepped-list--detailed": stepped && detailed,
      "is-dark": isDark,
      "is-split": split
    })
  }, props), generateItems({
    items,
    ticked,
    inline: inline || middot || stretch,
    middot,
    stepped
  }));
};
var _default = exports.default = List;